export default "__VITE_ASSET__Db7rj2Jk__"